import React, { useEffect, useReducer, useState } from "react";
import { Row, Col, Card, CardHeader, CardBody, Spinner } from "reactstrap";
import { getJournal } from "states/person/PersonDatasource";
import PersonReducer from "states/person/PersonReducer";
import { FETCH_SUCCESS, FETCH_FAILED } from "states/person/PersonType";
import DataTable from "react-data-table-component";
import _ from "lodash"

const INIT_DATA = {
  loading: true,
  data: null,
  itemsCount: 0,
};
function TableData(items) {
  const [keyword, setKeyword] = useState()

  const columns = [
    {
      name: 'ปีที่ตีพิมพ์',
      selector: row => (row.yearEN) ? row.yearEN : "-",
      sortable: true,
      width: "100px",
      left: true,
    },
    {
      name: 'ชื่อผลงานตีพิมพ์/วารสาร',
      selector: row => row.title ? row.title : "-",
      sortable: true,
      wrap: true
    },
  ]

  function filterData(data) {
    if (keyword) {
      return data.filter(d => d.title.toLowerCase().indexOf(keyword) > -1)
    } else {
      return data;
    }
  }

  return (
    <div>
      {
        items.data.length > 0 && (
          <Row>
            <Col md={8} sm={12}>
            </Col>
            <Col md={4} sm={12}>
              <div className="input-group input-group-sm">
                <div className="input-group-prepend">
                  <span className="input-group-text"><i className="fa fa-search"></i></span>
                </div>
                <input type="text" className="form-control" onChange={e => setKeyword(e.target.value)} placeholder="ค้นหา..." />
              </div>
            </Col>
          </Row>
        )
      }
      <DataTable
        className="table-data"
        columns={columns}
        data={filterData(items.data)}
        pagination
        responsive
        striped
      />
    </div>
  )
}

export default function JournalSection({ staffId }) {
  const [state, dispatch] = useReducer(PersonReducer, INIT_DATA);

  const fetchData = async () => {
    try {
      const resp = await getJournal(staffId);

      if (resp.status === 1) {
        const payload = {
          data: _.orderBy(resp.result, ['year'], ['desc']),
          itemsCount: resp.itemsCount,
        };
        return dispatch({ type: FETCH_SUCCESS, payload });
      } else {
        return dispatch({ type: FETCH_FAILED, error: "Fetch failed" });
      }
    } catch (error) {
      return dispatch({ type: FETCH_FAILED, error: error.message });
    }
  };

  useEffect(() => {
    if (state.loading) {
      if (staffId) {
        setTimeout(() => {
          fetchData();
        }, 1000);
      } else {
        console.log("No id to query");
      }
    }
  });

  return (
    <div className="section">
      <Card className="card-section">
        <CardHeader>
          <i className="fas fa-book"></i>
          <span> บทความวิชาการ</span>
        </CardHeader>
        <CardBody>
          {!state.data ? (
            <div className="text-center">
              <Spinner />
            </div>
          ) : (
            <TableData data={state.data} />
          )}
        </CardBody>
      </Card>
    </div>
  );
}
